import { statusTagColors } from '@/const'
import { PBJ_PAY_TYPE_CODES } from '@/store/modules/report/constants'

export const PBJ_AUDIT_STATUS_META = Object.freeze({
  open: Object.freeze({ label: 'Open', color: '#2563eb' }),
  completed: Object.freeze({ label: 'Completed', color: statusTagColors.GRAY })
})

export const PBJ_AUDIT_UNKNOWN_STATUS_META = Object.freeze({ label: 'Unknown', color: statusTagColors.GRAY })

export const PBJ_AUDIT_MARKER_META = Object.freeze({
  moved_date: Object.freeze({ label: 'Moved date', color: '#d97706' }),
  new_shift: Object.freeze({ label: 'New shift', color: '#16a34a' }),
  changed_hours: Object.freeze({ label: 'Changed hours', color: '#2563eb' }),
  deleted_shift: Object.freeze({ label: 'Deleted shift', color: '#dc2626' }),
  new_cdph_530_on_apply: Object.freeze({ label: 'New CDPH-530 on apply', color: '#7c3aed' })
})

export const PBJ_AUDIT_UNKNOWN_MARKER_META = Object.freeze({ label: 'Draft change', color: statusTagColors.GRAY })

export const PBJ_AUDIT_PAY_TYPE_TITLES = Object.freeze(
  PBJ_PAY_TYPE_CODES.reduce((titles, item) => ({ ...titles, [item.code]: item.title }), {})
)
